import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Switch } from "../components/ui/switch";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../context/LangContext";

const KEYS = [
  { key: "email_confirmation", label: "n_email" },
  { key: "push_reminders", label: "n_push" },
  { key: "new_experiences", label: "n_new" },
  { key: "last_minute_offers", label: "n_offers" },
];

export default function Notifications() {
  const navigate = useNavigate();
  const { user, setUser } = useAuth();
  const { t } = useLang();
  const [prefs, setPrefs] = useState({
    email_confirmation: true,
    push_reminders: true,
    new_experiences: true,
    last_minute_offers: false,
  });
  const [savedFlag, setSavedFlag] = useState(false);

  useEffect(() => {
    if (user?.notifications) setPrefs((p) => ({ ...p, ...user.notifications }));
  }, [user]);

  const toggle = async (key) => {
    const next = { ...prefs, [key]: !prefs[key] };
    setPrefs(next);
    const { data } = await api.put("/users/me/notifications", next);
    setUser(data);
    setSavedFlag(true);
    setTimeout(() => setSavedFlag(false), 1200);
  };

  return (
    <div className="px-6 pt-6 pb-10" data-testid="notifications-page">
      <button
        onClick={() => navigate(-1)}
        data-testid="notif-back"
        className="inline-flex items-center gap-2 text-brand-brown/70 text-xs tracking-[0.25em] uppercase font-bold"
      >
        <ArrowLeft size={14} /> {t("profile")}
      </button>

      <header className="mt-8">
        <p className="text-[10px] tracking-[0.45em] uppercase font-bold text-brand-tan">
          {t("profile")}
        </p>
        <h1 className="font-serif text-4xl text-brand-brown mt-2 leading-[1.05]">
          {t("notifications")}
        </h1>
      </header>

      <ul className="mt-10 space-y-3">
        {KEYS.map(({ key, label }) => (
          <li
            key={key}
            data-testid={`pref-${key}`}
            className="flex items-center justify-between rounded-2xl border border-brand-tan/25 bg-white/60 p-4"
          >
            <span className="font-bold text-brand-brown text-sm tracking-wide pr-4">
              {t(label)}
            </span>
            <Switch
              checked={prefs[key]}
              onCheckedChange={() => toggle(key)}
              data-testid={`switch-${key}`}
              className="data-[state=checked]:bg-brand-brown"
            />
          </li>
        ))}
      </ul>

      <p
        className={`text-[10px] tracking-[0.35em] uppercase font-bold text-brand-green mt-6 text-center transition-opacity ${
          savedFlag ? "opacity-100" : "opacity-0"
        }`}
        data-testid="saved-flag"
      >
        {t("saved")}
      </p>
    </div>
  );
}
